module.exports = __webpack_public_path__ + "static/media/silka-black-webfont.fbce246e.ttf";